import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * appends extra class to original classname, returns new full class string
 */
export function cloneWithHashClass(originalClass, extraClass) {
  if (typeof originalClass === 'string') {
    originalClass = originalClass.split(' ');
  }
  return [].concat(_toConsumableArray(originalClass || []), [extraClass]).filter(Boolean).join(' ');
}